export default __webpack_public_path__ + "static/media/mastercard_logo.869b0d32.svg";